<template>
  <div class="card mt-3">
    <header class="card-header has-background-info-dark">
      <p class="card-header-title has-text-info-light">
        Članovi klana
      </p>
    </header>
    <div class="card-content">
      <div class="table-container">
        <table
          class="table is-bordered is-striped
        is-narrow is-hoverable is-fullwidth is-size-7-mobile is-size-7-touch"
        >
          <thead>
            <tr>
              <th>#</th>
              <th>Ime</th>
              <th>Trofeji</th>
              <th>Status</th>
              <th>Lvl</th>
              <th>Arena</th>
              <th>Zadnje online</th>
            </tr>
          </thead>
          <tfoot>
            <tr>
              <th>#</th>
              <th>Ime</th>
              <th>Trofeji</th>
              <th>Status</th>
              <th>Lvl</th>
              <th>Arena</th>
              <th>Zadnje online</th>
            </tr>
          </tfoot>
          <tbody>
            <tr v-for="member in members" :key="member.tag">
              <td>
                {{ member.rank }}
              </td>
              <td>
                <router-link :to="'/member/' + member.tag.substring(1)">
                  {{ member.name }}
                </router-link>
              </td>
              <td>{{ member.trophies }}</td>
              <td>{{ member.role }}</td>
              <td>{{ member.level }}</td>
              <td>{{ member.arena }}</td>
              <td>{{ member.lastSeen | moment('from', 'now') }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api';

export default {
  setup() {
    const apiHost = process.env.VUE_APP_API_HOST;
    const membersURL = '/clan/members';

    const members = ref([]);

    const API_URL = apiHost;

    async function getMembers() {
      const response = await fetch(API_URL + membersURL);
      const json = await response.json();
      members.value = json;
    }

    getMembers();

    return {
      members,
    };
  },
};
</script>

<style></style>
